import { client } from 'utilities/db';
import { useQuery } from 'react-query';

export const useFetchOneBranchHook = (keyName, id, brandType) => {
  const { status, data, error, isFetching, isLoading, refetch } = useQuery(
    [keyName, id, brandType],
    () => getBranch(id, brandType),
    {
      enabled: !!id || !!brandType,
      refetchInterval: 60000
    }
  );

  return {
    oneBranchStatus: status,
    oneBranchData: data,
    oneBranchError: error,
    oneBranchFetching: isFetching,
    oneBranchLoading: isLoading,
    oneBranchRefetch: refetch
  };
};

const getBranch = async (id, brandType) => {
  let result = null;
  if (brandType === 'CLOUD') {
    result = await client.get(`/cloudKitchen/findOne/${id}`);
    result = result.data;
    result = result?.cloudKitchenDetails;
  } else {
    result = await client.get(`/branch/findOne/${id}`);
    result = result.data;
    result = result?.branchDetails;
  }

  return result;
};
